
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, IPaintableOnEditing, instanceOfIPaintableOnEditing } from "../../../../../domain/document/items";
import { PaintStyle } from "../../../../../domain/drawing";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { IObjectStyleReadable } from "../../IObjectStyleReadable";

@Component({
})
export default class EditPainterPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editStyleReader: IObjectStyleReadable;
  editingSource: IDrawableItem;
  writeProperty: (write: (source: IPaintableOnEditing) => void) => void;

  get paintStyleOnEditing(): PaintStyle {
    return (instanceOfIPaintableOnEditing(this.editingSource) && this.editStyleReader)
      ? this.editStyleReader.readPaintStyle(this.editingSource, false)
      : undefined;
  }

  set paintStyleOnEditing(value: PaintStyle) {
    this.writeProperty(s => s.paintStyleOnEditing = value);
  }
}
